import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  data: {},
  success: null,
};

const postCustomShirtSlice = createSlice({
  name: "postCustomShirt",
  initialState,
  reducers: {
    postCustomShirtStart(state, payload) {
      state.loading = true;
      state.error = null;
    },

    postCustomShirtSuccess(state, action) {
      state.loading = false;
      state.data = action.payload.data.data;
      state.success = action.payload.data.message;
    },
    postCustomShirtFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
    clearLoading: (state) => {
      state.loading = false;
    },
  },
});

export const {
  postCustomShirtStart,
  postCustomShirtSuccess,
  postCustomShirtFailure,
  clearState,
  clearLoading,
} = postCustomShirtSlice.actions;

export default postCustomShirtSlice.reducer;
